import React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';

import RightChevron from './RightChevron';
import Spinner from './Spinner';

const Button = styled.button`
  color: ${props => props.theme.onSuccess}
  fill: ${props => props.theme.onSuccess}
  width: 140px;
  height: 50px;
  font-size: 14px;
  background: ${props => props.theme.success};
  border: none;
  text-align: center;
  white-space: nowrap;
  :disabled {
    background: ${props => props.theme.gray};
  }
`;

const Text = styled.span`
  text-align: right;
`;

const Chevron = styled.span`
  margin-left: 13px;
  margin-right: -23px;
`;

const NextPageButton = ({ t, text, loading, disabled, ...others }) => (
  <Button disabled={loading || disabled} {...others}>
    {loading ? (
      <Spinner />
    ) : (
      <>
        <Text>{text || t('button.send')}</Text>
        <Chevron>
          <RightChevron />
        </Chevron>
      </>
    )}
  </Button>
);

export default translate()(NextPageButton);
